import { ModelBase } from './ModelBase';
import { StoryModel } from './StoryModel';

const SERIALISE_KEYS = [
  '_coins',
  '_heroesUnlocked',
  '_highscores',
  '_weaponSkins',
  '_comboFinishers',
  '_story',
];
const MODEL_ID = 'player';

export default class PlayerModel extends ModelBase {
  constructor(game, { freeHeroes }) {
    super('Player', { colour: 'cyan', serialize: SERIALISE_KEYS });
    this.game = game;
    this._activeHero = false;
    this._coins = 0;
    this._heroesUnlocked = freeHeroes;
    this._highscores = {};
    this._activeStage = false;
    this._weaponSkins = {};
    this._comboFinishers = {};
    this._story = new StoryModel({ levels: this.game.model.getStoryLevels() });
    this._hasStorage = StorageAvailable();
    this.log('created', this._heroesUnlocked);
    this.load();
  }

  get story() {
    return this._story;
  }

  get coins() {
    return this._coins;
  }

  get activeHero() {
    return this._activeHero;
  }

  registerScore(stageid, score) {
    if (!this._highscores[stageid] || this._highscores[stageid] < score) {
      this._highscores[stageid] = score;
      this.log('new highscore : ' + stageid + ', ' + score);
      return true;
    }
    return false;
  }

  getHighScore(stageid) {
    return this._highscores[stageid] || 0;
  }

  unlockHero(heroid) {
    if (!this.hasUnlockedHero(heroid)) {
      this._heroesUnlocked.push(heroid);
      this.log('unlock hero : ' + heroid);
      this.dispatchUpdate();
      this.save();
    }
  }

  hasUnlockedHero(characterid) {
    return this._heroesUnlocked.includes(characterid);
  }

  unlockComboFinsiher(heroid, finsiherid) {
    if (!this._comboFinishers[heroid]) {
      this._comboFinishers[heroid] = { active: 0, unlocked: [0] };
    }
    this._comboFinishers[heroid].active = finsiherid;
    this._comboFinishers[heroid].unlocked.push(finsiherid);
    this.save();
  }

  hasUnlockedComboFinsiher(heroid, finsiherid) {
    return (
      this._comboFinishers[heroid] && this._comboFinishers[heroid].unlocked.includes(finsiherid)
    );
  }

  getActiveComboFinsiherId(heroid) {
    return this._comboFinishers[heroid]?.active || false;
  }

  unlockWeaponSkin(weaponid, skinid) {
    if (!this._weaponSkins[weaponid]) {
      this._weaponSkins[weaponid] = { active: false, unlocked: [] };
    }
    this._weaponSkins[weaponid].active = skinid;
    this._weaponSkins[weaponid].unlocked.push(skinid);
    this.save();
  }

  hasUnlockedWeaponSkin(weaponid, skinid) {
    return this._weaponSkins[weaponid]?.unlocked.includes(skinid);
  }

  getActiveWeaponSkin(weaponid) {
    return this._weaponSkins[weaponid]?.active || false;
  }

  addCoins(value) {
    this.adjustCoins(value);
  }
  removeCoins(value) {
    this.adjustCoins(-value);
  }
  adjustCoins(value) {
    this._coins += value;
    this.log('coins updated : ' + this._coins);
    this.dispatchUpdate();
    this.save();
    return this._coins;
  }

  startNewStory() {
    this.log('create new story');
    this._story = new StoryModel({ levels: this.game.model.getStoryLevels() });
    this.save();
  }

  jumpToStoryStage(stageid) {
    this.startNewStory();
    this.story.jumpToStage(stageid);
    this.save();
  }

  hasStoryProgress() {
    return this._story && this._story.hasProgress();
  }

  setActiveHero(id) {
    this._activeHero = id;
    this.log('character set : ' + this._activeHero);
  }

  getActiveHero() {
    return this._activeHero;
  }

  /*
   * Save Methods
   */
  load() {
    if (this._hasStorage) {
      const data = this.game.saves.getSave(MODEL_ID).player;
      if (data) ModelBase.DeserializeObject(this, data, SERIALISE_KEYS);
    }
  }

  save() {
    if (this._hasStorage) {
      const data = this.game.saves.serialize(this, MODEL_ID, SERIALISE_KEYS);
      this.game.saves.save({ id: MODEL_ID, data });
      this.log('saved');
    }
  }
}

const StorageAvailable = () => {
  var test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};
